var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66602 12.0002C8.66602 12.7365 9.26297 13.3335 9.99935 13.3335C10.7357 13.3335 11.3327 12.7365 11.3327 12.0002C11.3327 11.2638 10.7357 10.6668 9.99935 10.6668C9.26297 10.6668 8.66602 11.2638 8.66602 12.0002ZM8.66602 16.6667C8.66602 17.403 9.26297 18 9.99935 18C10.7357 18 11.3327 17.403 11.3327 16.6667C11.3327 15.9303 10.7357 15.3333 9.99935 15.3333C9.26297 15.3333 8.66602 15.9303 8.66602 16.6667ZM8.66602 7.33317C8.66602 8.06955 9.26297 8.6665 9.99935 8.6665C10.7357 8.6665 11.3327 8.06955 11.3327 7.33317C11.3327 6.59679 10.7357 5.99984 9.99935 5.99984C9.26297 5.99984 8.66602 6.59679 8.66602 7.33317Z",
    fill: "#B2B2B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.666 12.0002C12.666 12.7365 13.263 13.3335 13.9993 13.3335C14.7357 13.3335 15.3327 12.7365 15.3327 12.0002C15.3327 11.2638 14.7357 10.6668 13.9993 10.6668C13.263 10.6668 12.666 11.2638 12.666 12.0002ZM12.666 16.6667C12.666 17.403 13.263 18 13.9993 18C14.7357 18 15.3327 17.403 15.3327 16.6667C15.3327 15.9303 14.7357 15.3333 13.9993 15.3333C13.263 15.3333 12.666 15.9303 12.666 16.6667ZM12.666 7.33317C12.666 8.06955 13.263 8.6665 13.9993 8.6665C14.7357 8.6665 15.3327 8.06955 15.3327 7.33317C15.3327 6.59679 14.7357 5.99984 13.9993 5.99984C13.263 5.99984 12.666 6.59679 12.666 7.33317Z",
    fill: "#B2B2B2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default ForwardRef;